import i18n from "../i18n";

const STATUS_FALLBACK_AZ = {
    FINISHED: "Bitib",
    STARTED: "Başlayıb",
    ACTIVE: "Aktiv",
    IN_PROGRESS: "Davam edir",
    SUBMITTED: "Təhvil verilib",
    AUTO_SUBMITTED: "Avtomatik təhvil verilib",
    TIME_EXPIRED: "Vaxtı bitib",
    DISQUALIFIED: "Diskvalifikasiya olunub",
    CONFIRMED: "İmtahan nəticəsi təsdiqlənib",
    CANCELLED: "İmtahan nəticəsi ləğv edilib",
    EXAM_CANCELLED: "İmtahan ləğv edilib",
    PENDING: "Gözləmədə",
    RE_ENTER: "Yenidən daxil olub",
    PASS: "Uğurlu",
    FAIL: "Uğursuz",
};

export const STATUS_TEXT_AZ = STATUS_FALLBACK_AZ;

export function toStatusText(value) {
    if (value === null || value === undefined) return "-";
    const key = String(value).toUpperCase();
    const translated = i18n.t(`examStatus.${key}`, { defaultValue: "" });
    if (translated) return translated;
    return STATUS_FALLBACK_AZ[key] || key;
}

export const toStatusAz = toStatusText;
